import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-exam-lock-passphrase-dialog',
  templateUrl: './exam-lock-passphrase-dialog.component.html'
})
export class ExamLockPassphraseDialogComponent {
  title = '';
  message = '';
  passphrase = '';
  error = '';
  invalidPassphraseMessage = '';

  constructor(public modal: NgbActiveModal) {}

  submit() {
    this.error = '';
    if (!this.passphrase) {
      this.error = this.invalidPassphraseMessage || 'Passphrase is required.';
      return;
    }
    this.modal.close(this.passphrase);
  }
}
